module.exports = __webpack_public_path__ + "media/images/topbild-650-f05096aa54381fd19b271a1ec0b7f8f0.jpg";